/**
 * Public facing custom enrollment module
 */
app.skava = (function() {
    "use strict";
    var shoppingModes = {
            bwm: {
                urlPrefix: 'bwm'
            },
            cart: {
                urlPrefix: 'atc'
            }
        },
        selectedShoppingMode = 'cart',
        skavaErrorCallback,
        enrollmentComplete = false,
        productsTotal = 0,
        productCategories = [],
        cartData = {
            items: [],
            value: {
                grandTotal: 0
            }
        },
        propertiesData = {
            referralId: false,
            isTCVersionChecked: false
        },
        signupData = {},
        pageData = {},
        sessionObj = {
            access_token: null,
            sid: null
        },
        storageKey = 'myyl_sid',
        tokenKey = 'c_yl_skava',
        regexMap = {
            length: RegExp('^.{8,12}'),
            number: RegExp('^.*[0-9]'),
            upper: RegExp('^.*[A-Z]'),
            special: RegExp('^.*[!@#$%^&*()]'),
            alpha: RegExp('^.*[A-Za-z]'),
            zip: /(^\d{5}$)|(^\d{5}-\d{4}$)/
        },

        fieldSet = {
            signup: {
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                password: '',
                confirmPassword: '',
                required: ['firstName', 'lastName', 'phone', 'email', 'password', 'confirmPassword']
            },
            address: {
                addressId: '',
                firstName: '',
                lastName: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                country: '',
                zip: '',
                phone: '',
                email: '',
                required: ['firstName', 'lastName', 'addressLine1', 'city', 'state', 'country', 'zip', 'phone', 'email']
            },
            billing: {
                id: '',
                name: '',
                lastName: '',
                cardNumber: '',
                cardExpiration: '',
                expiryMonth: '',
                expiryYear: '',
                cvv: '',
                required: ['name', 'lastName', 'cardNumber', 'cardExpiration', 'cvv']
            },
            billingAddress: {
                firstName: '',
                lastName: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                country: '',
                zip: '',
                phone: '',
                email: '',
                required: ['addressLine1', 'city', 'state', 'country', 'zip']
            }
        },

        errorBanners = false,
        sameAsShipping = true,
        summary = {},
        promoCode = '',
        submitRetries = 5,
        paymentInfo = false,
        subscriptionId = false,
        subscriptionList = [],
        // after removing and submitting subscriptions, this is for the status modal
        loyaltyData = {
            removed: [],
            added: []
        },
        contactEmail = false,

        self = {

        BWM_SHOPPING_MODE: 'bwm',
        CART_SHOPPING_MODE: 'cart',

        init: function() {
            //
        },

        getFieldCountries: function() {
            return { US: { name: 'United States' }};
        },

        getFieldStates: function() {
            return {
                'Alabama': 'AL',
                'Alaska': 'AK',
                'Arizona': 'AZ',
                'Arkansas': 'AR',
                'California': 'CA',
                'Colorado': 'CO',
                'Connecticut': 'CT',
                'Delaware': 'DE',
                'District Of Columbia': 'DC',
                'Florida': 'FL',
                'Georgia': 'GA',
                'Hawaii': 'HI',
                'Idaho': 'ID',
                'Illinois': 'IL',
                'Indiana': 'IN',
                'Iowa': 'IA',
                'Kansas': 'KS',
                'Kentucky': 'KY',
                'Louisiana': 'LA',
                'Maine': 'ME',
                'Maryland': 'MD',
                'Massachusetts': 'MA',
                'Michigan': 'MI',
                'Minnesota': 'MN',
                'Mississippi': 'MS',
                'Missouri': 'MO',
                'Montana': 'MT',
                'Nebraska': 'NE',
                'Nevada': 'NV',
                'New Hampshire': 'NH',
                'New Jersey': 'NJ',
                'New Mexico': 'NM',
                'New York': 'NY',
                'North Carolina': 'NC',
                'North Dakota': 'ND',
                'Ohio': 'OH',
                'Oklahoma': 'OK',
                'Oregon': 'OR',
                'Pennsylvania': 'PA',
                'Rhode Island': 'RI',
                'South Carolina': 'SC',
                'South Dakota': 'SD',
                'Tennessee': 'TN',
                'Texas': 'TX',
                'Utah': 'UT',
                'Vermont': 'VT',
                'Virginia': 'VA',
                'Washington': 'WA',
                'West Virginia': 'WV',
                'Wisconsin': 'WI',
                'Wyoming': 'WY'
            };
        },

        /**
         * YL OAuth
         */
        signIn: function() {
            var resumeHash = '#build/info';

            if (selectedShoppingMode === self.CART_SHOPPING_MODE) {
               resumeHash = "#checkout";
            }

            // localhost can skip this
            if (mode == 'local') {
                // window.location.replace(resumeHash);
                self.identityContinue(true);

            } else {
                app.ga.event('login', { method: 'Checkout' });
                app.page.showLoader();
                self.setRedirectCookie();

                // optionally add &initial_screen=signup for account creation
                var url = self.getOpenIdUrl() +'&referral_id='+ app.main.getProfile().member_id +'&locale='+ app.main.getYLCulture();
                window.location.replace(url);
            }
        },

        /**
         * Set resume/redirect cookies
         */
        setRedirectCookie: function(extended) {
            var resumeHash = '#build/info',
                ttl = extended ? 48 : 0.25; // hours

            if (selectedShoppingMode === self.CART_SHOPPING_MODE) {
               resumeHash = "#checkout";
            }

            app.cookie.set(resumeHash, 'myyl_resume', ttl);
            // store url for callback
            app.cookie.set(window.location.origin + window.location.pathname +'#resume', 'myyl_redirect', ttl);
            console.log('myyl_redirect set for '+ ttl +' hours.')
        },

        /**
         * Set the session id from session response
         */
        setSessionId: function(id) {
            sessionObj.sid = id;
            app.cookie.set(JSON.stringify(sessionObj), storageKey, 8);
        },

        /**
         * Set the access token from session response
         */
        setToken: function(id) {
            sessionObj.access_token = id;
            app.cookie.set(JSON.stringify(sessionObj), storageKey, 8);
        },

        /**
         * Get the session object
         */
        getSessionObj: function() {
            var localObj = app.cookie.get(storageKey);
            
            if (localObj) {
                sessionObj = JSON.parse(localObj);
            }

            if (!sessionObj) {
                self.setUpSession(function() {
                    return sessionObj;
                }, function(err) {
                    //
                });

            } else {
                return sessionObj;
            }
        },

        /**
         * Get the access token
         */
        getToken: function() {
            if (self.isAuthenticated()) {
                return self.isAuthenticated();
            }

            if (sessionObj.access_token) {
                return sessionObj.access_token;
            }

            return false;
        },

        /**
         * Has the user logged in?
         */
        isAuthenticated: function() {
            var localObj = app.cookie.get(tokenKey),
                cookie = {};

            if (localObj) {
                try {
                    cookie = JSON.parse(localObj);

                    if (cookie.access_token) {
                        return cookie.access_token;
                    }

                } catch (e) {
                    //
                }
            }

            return false;
        },

        /**
         * Member ID of authenticated user
         */
        getCustomerId: function() {
            var localObj = app.cookie.get(tokenKey),
                cookie = {};

            if (localObj) {
                try {
                    cookie = JSON.parse(localObj);

                    if (cookie.member_id) {
                        return cookie.member_id;
                    }

                } catch (e) {
                    //
                }
            }

            return false;
        },

        /**
         * Return the sid for the current shopping mode
         */
        getSessionId: function() {
            // return sessionObj[self.getShoppingMode()].sid;
            return sessionObj.sid;
        },

        /**
         * Clear the previously stored session id
         **/
        clearSessionId: function() {
            sessionObj.sid = null;
            app.cookie.set(JSON.stringify(sessionObj), storageKey, 1);
        },

        /**
         * Helper to let other modules know if this user has subscriptions
         * If a product_id is passed, check for that specific subscription
         */
        hasSubscriptions: function(product_id) {
            if (product_id) {
                if (typeof product_id == 'number') {
                    product_id = product_id.toString();
                }

                return subscriptionList.includes(product_id);
            }

            return subscriptionId ? subscriptionId : false;
        },

        /**
         * Check for subscriptions
         */
        getSubscriptions: function(callback) {
            if (!callback) {
                callback = function() {};
            }

            app.skava.sendRequest({
                url: '/subscriptions/',
                method: 'GET'
            },

            function(res) {
                // success
                var response = JSON.parse(res);

                if (response.subscriptions) {
                    self.parseSubscriptions(response);
                    callback(response);

                } else {
                    callback(false);
                }
            },

            function(err) {
                // no subscriptionId
                callback(false);
            });
        },

        /**
         * Pull out products in subscription list
         * Data should be the JSON response from the subscriptions endpoint
         */
        parseSubscriptions: function(data) {
            subscriptionId = data.subscriptions[0].id;
            console.log('subscriptionId: '+ subscriptionId);

            subscriptionList = app.main.recursiveSearch(data, 'productId');
        },

        getSubscriptionList: function() {
            return subscriptionList;
        },

        /**
         * Create a subscription
         * If id is passed, subscription will be attached to that id
         */
        createSubscription: function(data, callback, errCallback) {
            console.log('subData', data);
            var url = '/subscriptions/';

            if (subscriptionId) {
                console.log('add loyalty item to: '+ subscriptionId);

            } else {
                console.log('create new loyalty order');
            }

            if (!callback) {
                callback = function() {};
            }

            app.skava.sendRequest({
                url: url,
                method: 'POST',
                data: JSON.stringify(data)
            },

            function(res) {
                // success
                console.log(res);
                callback(res);
            },

            function(err) {
                // fail
                console.log('create subscription failed');

                try {
                    console.table(JSON.parse(err.responseText));

                } catch(error) {
                    //
                }

                if (errCallback) {
                    errCallback(err);

                } else {
                    callback(err);
                }
            });
        },

        /**
         * Helper function to clean up the hash if needed
         */
        getHash: function() {
            var hash = window.location.hash.substr(1).toLowerCase();

            // remove initial slash if it exists
            if (hash.substr(0, 1) == '/') {
                hash = hash.substr(1);
            }

            return hash;
        },

        setShoppingMode: function(mode, errorCb) {
            if (!app.main.getSettings().skavaEnabled) {
                return;
            }

            selectedShoppingMode = mode;
            skavaErrorCallback = errorCb;
            app.cookie.set(JSON.stringify({ mode: mode }), 'myyl_shopping_options', 1);

            self.setUpSession(self.loadCategories);
        },

        getShoppingMode: function(override) {
            if (override) {
                selectedShoppingMode = override;
            }

            var cookieValue = app.cookie.get('myyl_shopping_options');

            if (cookieValue) {
                var mode = JSON.parse(cookieValue).mode;

                if (mode) {
                    selectedShoppingMode = JSON.parse(cookieValue).mode;
                }
            }

            return selectedShoppingMode;
        },

        groupProductsByCategory: function(products) {
            var organizedProducts = {};

            for (var i = 0; i < products.length; i++) {
                if (!products[i].categories || products[i].categories.length === 0) {
                    if (productCategories.length) {
                        products[i].categories = [productCategories[0].id]; // Todo: sometimes product has no category, so for now put default if not found
                    }
                }

                var category = self.getCategoryByID(products[i].categories[0]);

                if (!category) {
                    // set to a default
                    if (productCategories.length) {
                        console.log('set default category');
                        category = self.getCategoryByID(productCategories[0].id);
                    }
                }

                if (category) {
                    if (!organizedProducts[products[i].categories[0]]) {
                        organizedProducts[products[i].categories[0]] = {
                            categoryTitle: category.name,
                            products: []
                        };
                    }

                    organizedProducts[products[i].categories[0]].products.push(products[i]);

                } else {
                    console.log('no category found for ', products[i].name);
                }
            }

            return organizedProducts;
        },

        loadCategories: function(finishedCb) {
            if (typeof finishedCb !== 'function') {
                finishedCb = function() {};
            }

            // skip if already loaded
            if (productCategories.length > 0) {
                if (typeof finishedCb == 'function') {
                    finishedCb();
                }
                return;
            }

            var file = app.main.getSettings().skavaEnabled ? 'categories-v2.json' : 'categories.json';

            $.getJSON(assetURL[mode] +'json/'+ app.main.getCurrentCulture() +'/'+ file + cb)
                .done(function(cats) {
                    productCategories = cats;

                    productCategories.forEach(function(cat) {
                        cat.products = [];
                    });

                    finishedCb();

                }).fail(function(a, b, c) {
                    // todo: error handling
                });
        },

        /**
         * Helper to provide categories to other modules
         */
        getCategories: function() {
            return productCategories;
        },

        /**
         * Get a category by ID
         */
        getCategoryByID: function(id) {
            // console.log('searching for categoryID '+ id);

            for (var i=0; i<productCategories.length; i++) {
                if (productCategories[i].id == id) {
                    return productCategories[i];
                }
            }
        },

        /**
         * Return discounted price or retail price
         */
        getPrice: function(product) {
            if (product.promo) {
                return product.promo.priceAfterDiscount;

            } else {
                return product.retail_price;
            }
        },

        renderCartReview: function(container, pageData) {
            self.loadCategories(function() {
                pageData.productsByCategory = self.groupProductsByCategory(pageData.products);
                var cartProducts = [],
                    cartMonthly = [],
                    productTotal = 0,
                    subscriptionTotal = 0;

                pageData.products.forEach(function(item) {
                    if (item.isSubscription) {
                        cartMonthly.push(item);
                        subscriptionTotal += self.getPrice(item);

                    } else {
                        cartProducts.push(item);
                        productTotal += self.getPrice(item);
                    }
                });

                pageData.cart = {
                    products: cartProducts,
                    subscriptions: cartMonthly
                };

                pageData.productTotal = productTotal;
                pageData.subscriptionTotal = subscriptionTotal;

                var temp = app.main.getTemplate('cart-review', pageData);
                var existingProducts = $(container + ' #cart-review-products');

                if (existingProducts) {
                    existingProducts.remove();
                }

                $(container).append(temp);

                $('#promo-container').html(app.main.getTemplate('promo-form', {}));
                self.initPromoForm();

                app.cart.setupClickEvents();
            });
        },

        renderForm: function(container, data) {
            console.log('renderForm');
            pageData = data;
            pageData.gifts = self.getCartGifts();

            self.validateSubscriptions();

            self.getShoppingMode(self.CART_SHOPPING_MODE);
            app.main.toggleNavigation();

            if (!pageData.products || pageData.products.length === 0) {
                // no products, show a message?

            } else {
                // check to see if there are any be kits in the cart
                // todo: check member type and remove be kits if logged in as a bp
                // pageData.products.forEach(function(product) {
                //     if (product.business_essentials_kit) {
                //         pageData.brandPartnerApply = true;
                //         console.log('brand partner apply');
                //     }
                // });
            }

            if (selectedShoppingMode === this.CART_SHOPPING_MODE) {
                self.loadCategories(function() {
                    self.finishRenderForm(container, pageData);
                });

            } else {
                self.finishRenderForm(container, pageData);
            }

            // debug - ctrl+c will reveal the confirm accordion panel
            $(document).off('keyup').on('keyup', function(e) {
                if (e.ctrlKey && e.keyCode == 67) {
                    $('.confirm-panel').toggleClass('active');
                }
            });
        },

        getOpenIdUrl: function() {
            // https://openidclone.youngliving.com/.well-known/openid-configuration

            var oidurl = {
                local: 'https://auth-stage.youngliving.com',
                dev: 'https://auth-stage.youngliving.com',
                test: 'https://auth.youngliving.com',
                live: 'https://auth.youngliving.com'
            };

            var providerInfo = {
                "issuer": oidurl[mode],
                "jwks_uri": oidurl[mode] + "/.well-known/openid-configuration/jwks",
                "authorization_endpoint": oidurl[mode] + "/connect/authorize",
                "token_endpoint": oidurl[mode] + "/connect/token",
                "userinfo_endpoint": oidurl[mode] + "/connect/userinfo",
                "end_session_endpoint": oidurl[mode] + "/connect/endsession",
                "check_session_iframe": oidurl[mode] + "/connect/checksession",
                "revocation_endpoint": oidurl[mode] + "/connect/revocation",
                "introspection_endpoint": oidurl[mode] + "/connect/introspect",
                "frontchannel_logout_supported": true,
                "frontchannel_logout_session_supported": true,
                "scopes_supported": ["openid", "profile", "email", "yl", "pws", "skava-pws", "offline_access"],
                "claims_supported": ["sub", "name", "family_name", "given_name", "middle_name", "nickname", "preferred_username", "profile", "picture", "website", "gender", "birthdate", "zoneinfo", "locale", "updated_at", "email", "email_verified", "country", "customer_type", "rank", "pws_subscription"],
                "grant_types_supported": ["authorization_code", "client_credentials", "refresh_token", "implicit"],
                "response_types_supported": ["code", "token", "id_token", "id_token token", "code id_token", "code token", "code id_token token"],
                "response_modes_supported": ["form_post", "query", "fragment"],
                "token_endpoint_auth_methods_supported": ["client_secret_basic", "client_secret_post"],
                "subject_types_supported": ["public"],
                "id_token_signing_alg_values_supported": ["RS256"],
                "code_challenge_methods_supported": ["plain", "S256"]
            };

            var clientInfo = {
                client_id: 'ylpws-skava',
                redirect_uri: window.location.href.split('/').slice(0, 3).join('/') + '/login-callback.html'
            };

            var req = {
                scope: 'yl openid profile email skava-pws',
                response_type: 'code'
            };

            OIDC.setClientInfo(clientInfo);
            OIDC.setProviderInfo(providerInfo);
            OIDC.storeInfo(providerInfo, clientInfo);
            // Remove State and Nonce from previous session
            sessionStorage.removeItem('state');
            sessionStorage.removeItem('nonce');
            var url = encodeURI(OIDC.generateLoginRequest(req).url);
            return url;
        },

        finishRenderForm: function(container, pageData) {
            console.log('finishRenderForm');
            pageData.shoppingMode = selectedShoppingMode;
            pageData.isAuthenticated = self.isAuthenticated();

            var pieces = decodeURIComponent(self.getHash()).split('/');
            var existingForm = $(container + ' #checkout-form');
            var hasErrors = false;
            var url;

            if (existingForm) {
                existingForm.remove();
            }

            $(container).append(app.main.getTemplate('checkout-form', pageData));

            if (selectedShoppingMode === this.CART_SHOPPING_MODE) {
                $('.price.products').text(app.global.currency(productsTotal));
                self.renderCheckoutConfirmPanel(pageData);
            }

            var gaCheckoutData = {
                'currency': app.global.currency(false).label,
                'value': self.getGrandTotal(),
                'coupon': self.getPromoCode(),
                'items': self.gaItems()
            };

            app.ga.event('begin_checkout', gaCheckoutData);

            // Handle sub pages
            $('#account-row').removeClass('active');
            $('#checkout-row').removeClass('active');
            $('.toggle-form-panel').each(function(index, item) {
                $('#' + item.id).removeClass('active');
            });

            if (pieces.length > 1) {
                var mainPage = pieces[0];
                var subPage = pieces[1];

                if (mainPage == 'checkout') {

                    if (subPage === 'signup') {
                        var isValid = true,
                            pwIsValid = true;

                        $('#account-row').addClass('active');
                        $('#signup-toggle-panel').addClass('active');

                        self.messageHandler('login-success');

                    } else if (subPage === 'new') {
                        $('#account-row').addClass('active');
                        $('#account-created-toggle-panel').addClass('active');

                    } else {
                        $('#account-row').addClass('active');
                        $('#account-toggle-panel').addClass('active');

                        if (self.isAuthenticated()) {
                            // mimic the iframe success handler
                            self.messageHandler('login-success');

                        } else {
                            self.signIn();
                            return false;
                        }
                    }

                } else {
                    // self.contactInfoPanel();
                    self.getPreferences();
                    // self.validateSubscriptions();
                }

            } else {
                // self.contactInfoPanel();
                self.getPreferences();
                // self.validateSubscriptions();
            }

            $('.accordion-panel h4').on('click', function (event) {
                event.stopPropagation();
                event.stopImmediatePropagation();

                if ($(this).parent().hasClass('enabled')) {
                    self.toggleAccordionPanel($(this).parent());
                }
            });

            // billing address same as shipping checkbox
            $('#field-billing-sameas').on('change', function (e) {
                if (this.checked) {
                    sameAsShipping = true;
                    $('#billing-address').removeClass('visible');

                    // clear fields
                    $('#billing-address .field input').each(function(index, field) {
                        $(field).val('').removeClass('error');
                    });

                    $('#billing-address .field-error').empty();

                    self.validateForm('billingAddress');
                    self.validateForm('billing');

                } else {
                    sameAsShipping = false;
                    $('#billing-address').addClass('visible');
                    self.validateForm('billing');
                    self.validateForm('billingAddress');
                }
            });

            // button clicks
            $(document).on('click', '.checkout-row .btn-continue', self.handleButtonClick);
            $(document).on('click', '.checkout-row a.form-action', self.handleButtonClick);
            app.page.hideLoader();
        },

        /**
         * Continue button click handler
         */
        handleButtonClick: function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();

            var currentPanel = $(this).attr('data-panel');

            switch (currentPanel) {
                // todo: deprecated
                case 'account-toggle-panel':
                    self.signInPanel();
                break;

                // todo: deprecated
                case 'signup-toggle-panel':
                    self.createAccountPanel();
                break;

                // todo: deprecated
                case 'account-created-toggle-panel':
                    self.accountConfirmPanel();
                break;

                case 'contact-info-panel':
                    self.validateContactInfoPanel();
                break;

                case 'shipping-address-panel':
                    self.shippingAddressPanel();
                break;

                case 'shipping-method-panel':
                    // self.shippingMethodPanel();
                    // self.initLoyalty();
                    // self.convertCart();
                    self.availability();
                break;

                case 'billing-panel':
                    self.billingPanel();
                break;

                case 'confirm-panel':
                    self.orderConfirmPanel();
                break;

                default:
                    self.shippingAddressPanel();
                break;
            }
        },

        /**
         * Accordion expand/collapse
         */
        toggleAccordionPanel: function(parentElement) {
            // panel tracking
            switch (parentElement) {
                case '#contact-info-panel':
                    app.ga.track('CART', 'Contact Information');
                break;
                case '#shipping-address-panel':
                    app.ga.track('CART', 'Shipping Information');
                break;
                case '#shipping-method-panel':
                    app.ga.track('CART', 'Shipping Options');
                break;
                case '#billing-panel':
                    app.ga.track('CART', 'Billing and Payment');
                break;
                case '#confirm-panel':
                    app.ga.track('CART', 'Order Confirmation');
                break;
            }

            app.page.hideLoader();

            if (enrollmentComplete) return;

            parentElement = $(parentElement);

            if (parentElement.hasClass('active')) {
                return;

            } else {
                parentElement.addClass('active').addClass('enabled');
                $('#checkout-row .accordion-panel').each(function (index, element) {
                    if ($(element).attr('id') !== $(parentElement).attr('id')) {
                        $(element).removeClass('active');
                    }
                });
            }
        },

        // update the panel high-level text
        updateHighlightText: function (id, text) {
            $(id + ' .panel-highlight').text(text).addClass('active');
        },

        /**
         * Zeroth step, check existing user with subscriptions and manage
         */
        validateSubscriptions: function() {
            if (!subscriptionId) {
                console.log('no subscriptionId. skip validateSubscriptions');
                return;
            }

            console.log('validateSubscriptions');

            var items = self.getCartSubscriptions(),
                sku, product, itemsToDelete = [];

            if (subscriptionId && items.length) {

                // check if items have already been subscribed to
                items.forEach(function(item) {
                    sku = item.skus[0];

                    if (subscriptionList.includes(sku.productId)) {
                        product = self.getProductByID(sku.productId);
                        console.log('already subscribed to '+ product.name);
                        itemsToDelete.push(item);
                    }
                });

                if (itemsToDelete.length > 0) {
                    var completed = 0;
                    // delete them and then move ahead
                    itemsToDelete.forEach(function(item) {
                        app.skava.sendRequest({
                                url: '/cart/' + item.itemId + '/',
                                method: 'DELETE'
                            },

                            function() {
                                // success
                                console.log('deleted subscription '+ item.itemId);
                                var exists = loyaltyData.removed.find(function(item2) {
                                    return item2.product_id === product.product_id;
                                });

                                if (!exists) {
                                    loyaltyData.removed.push(product);

                                } else {
                                    console.log('skipped adding dupe remove loyalty item to modal');
                                }

                                // loyaltyData.removed.push(product);

                                completed++;
                                if (completed == itemsToDelete.length) {
                                    // refresh the cart and continue
                                    self.getCart(self.submitLoyaltyOrders, self.submitLoyaltyOrders);
                                }
                            },

                            function(err) {
                                // fail
                                console.log('Failed to delete '+ item.itemId);
                                completed++;
                                if (completed == itemsToDelete.length) {
                                    // refresh the cart and continue
                                    self.getCart(self.submitLoyaltyOrders, self.submitLoyaltyOrders);
                                }
                            }
                        );
                    });

                } else  {
                    self.submitLoyaltyOrders();
                }
            }
        },

        /**
         * Submit all loyalty orders before normal checkout
         */
        submitLoyaltyOrders: function() {
            // if subscriptions are still in the cart, submit them
            var items = self.getCartSubscriptions(),
                product, sku, totalCost = 0;

            if (items.length) {
                items.forEach(function(item) {
                    sku = item.skus[0];
                    product = self.getProductByID(sku.productId);

                    if (product) {
                        var exists = loyaltyData.added.find(function(item2) {
                            return item2.product_id === product.product_id;
                        });

                        if (!exists) {
                            loyaltyData.added.push(product);
                            totalCost += product.price;

                        } else {
                            console.log('skipped adding dupe loyalty item to modal');
                        }

                    } else {
                        // there should never be a case where product is false at this point
                        console.log('product '+ sku.productId +' not found');
                    }
                });

                var subData = {
                    "items": items,
                    "totalCost": app.global.round(totalCost),
                    "referralId": app.main.getProfile().member_id,
                    "subscriptionId": subscriptionId
                };

                self.createSubscription(subData,
                    function(res) {
                        // success
                        console.log('subscriptions submit ok');

                        self.deleteCartSubscriptions(
                            function(data) {
                                // finished
                                self.openLoyaltyStatusModal();
                            }
                        );
                    },

                    function(err) {
                        //
                    }
                );

            } else {
                console.log('no loyalty orders to submit');
                // modal will only appear if items were removed
                self.openLoyaltyStatusModal();
            }
        },

        /**
         * First step, get preferences endpoint
         */
        getPreferences: function() {
            // console.log('getPreferences');
            // if logged in, don't show the contact panel

            var url = '/preferences/';

            if (subscriptionId) {
                url += subscriptionId +'/';
            }

            app.skava.sendRequest({
                url: url,
                method: 'GET'
            },

            function(res) {
                // success
                // console.log('preferences success');
                if (self.isAuthenticated()) {
                    self.populateAddresses();

                } else {
                    self.contactInfoPanel();
                }
            },

            function(err) {
                // fail
                // console.log('preferences failed');

                try {
                    console.log(JSON.parse(err.responseText).responseMessage);

                } catch(error) {
                    //
                }

                if (self.isAuthenticated()) {
                    self.populateAddresses();

                } else {
                    self.contactInfoPanel();
                }
            });
        },

        populateAddresses: function() {
            var $target = $('#shipping-address-panel');

            self.getSavedAddresses(function(data) {
                // enable address form tabs
                $('.tabs div', $target).on('click', function(e) {
                    $('.tabs div,.tab', $target).removeClass('is-active');
                    $(this).addClass('is-active');
                    $('#'+ $(this).data('tab')).addClass('is-active');
                });

                if (data.length < 1) {
                    $('#tab-new-address').click();
                    $('#tabs-addresses').hide();

                } else {

                    // check for dupes
                    data = self.deDupe(data);

                    // fallback for bad data that doesn't include a required email address
                    var c = app.cookie.get('myyl_sid'),
                        ylEmail = '';
                    
                    if (c) {
                        var cData = JSON.parse(c);

                        if (cData.access_token) {
                            var tokenData = self.decodeToken(cData.access_token);

                            if (tokenData.email) {
                                ylEmail = tokenData.email;
                            }
                        }
                    }

                    data.forEach(function(address) {
                        if (!address.email && ylEmail) {
                            // console.log('Set email to '+ ylEmail +' on address '+ address.addressLine1);
                            address.email = ylEmail;
                        }
                    });

                    // populate saved addresses
                    $('#tab-saved-addresses').text(app.main.lang('tab_saved_addresses') +' ('+ data.length +')');
                    $('#address-saved').empty().html(app.main.getTemplate('partial-address', { addresses: data }));

                    $('.address input').on('change', function(e) {
                        var index = parseInt($(this).val(), 10);
                        var address = Object.assign({}, fieldSet.address, data[index]);

                        self.populateAddressForm(address);

                        fieldSet.address = address;

                        $('#shipping-address-panel .btn-continue').removeClass('is-disabled');
                    });

                    // auto-select the first address
                    $('#address-0').click();
                }

                // standard cart address form
                $('#checkout-row').addClass('active');
                self.getSummary();

                // set initial country value
                fieldSet.address.country = $('#field-address-country option:checked').val().toUpperCase();

                // set up validation for the shipping address form
                self.validateForm('address');

                $('#field-address-email').off('keyup').on('keyup', function(e) {
                    self.validateForm('address');
                });
            });
        },

        // dedupe addresses/payment methods
        deDupe: function(arr) {
            return arr.reduce(function(p, c) {

                var id = [c.firstName, c.lastName, c.addressLine1, c.phone, c.zip].join('|');

                // only payment methods have a type
                if (arr[0] && arr[0].type =='CREDITCARD') {
                    id = [c.accountInfo.cardNumber, c.accountInfo.expiryMonth, c.accountInfo.expiryYear].join('|');
                }

                if (p.temp.indexOf(id) === -1) {
                    p.out.push(c);
                    p.temp.push(id);
                }

                return p;

            }, {
                temp: [],
                out: []
            }).out;
        },

        /**
         * Sign in panel
         */
        signInPanel: function() {
            app.page.showLoader();

            var textFields = ['username', 'password'];
            var formFields = {};

            for (var i = 0; i < textFields.length; i++) {
                var fieldId = '#account-toggle-panel #field-account-' + textFields[i];
                formFields[textFields[i]] = $(fieldId).val();
            }

            var clearForm = function () {
                for (var i = 0; i < textFields.length; i++) {
                    var fieldId = '#account-toggle-panel #field-account-' + textFields[i];
                    $(fieldId).val('');
                }
            };

            app.skava.account.login(formFields,
                function() {
                    clearForm();

                    if (selectedShoppingMode === self.CART_SHOPPING_MODE) {
                        window.location.hash = "#checkout";

                    } else {
                        window.location.hash = "#build/info";
                    }
                },

                function(res) {
                    app.page.hideLoader();
                    clearForm();
                    var invalidFields = self.handlePanelError('#account-toggle-panel', res);
                    if (invalidFields) {
                        for (var key in invalidFields) {
                            $('#account-toggle-panel #field-account-' + key).addClass('error');
                        }
                    }
                }
            );
        },

        /**
         * Create account form
         */
        createAccountPanel: function() {
            $('#signup-toggle-panel input').removeClass('error');
            $('.field-error').empty();

            app.page.showLoader();

            app.skava.account.create(signupData,
                function() {
                    $('#field-signup-password').val('');
                    $('#field-signup-confirmPassword').val('');
                    window.location.hash = "#checkout";
                },

                function(res) {
                    app.page.hideLoader();
                    var errors = self.handlePanelError('#signup-toggle-panel', res);

                    if (errors) {
                        if (errors.resultCode == 'EmailExists') {
                            $('#field-signup-email').addClass('error');
                            $('.field-error.email').text(app.main.lang('error_email_exists'));
                        }

                        for (var key in errors) {
                            var message = errors[key];
                            // use the lang code
                            if (message == 'This field may not be blank.') {
                                message = app.main.lang('error_required_field');
                            }

                            if (message == 'Passwords do not match.') {
                                message = app.main.lang('error_password_match');
                            }

                            $('#field-signup-'+ key).addClass('error');
                            $('.field-error.'+ key).text(message);
                        }
                    }
                }
            );
        },

        /**
         * Account confirmation (is this needed?)
         */
        accountConfirmPanel: function() {
            app.page.showLoader();

            var textFields = ['username', 'password'];
            var formFields = {};

            for (var i = 0; i < textFields.length; i++) {
                var fieldId = '#field-account-' + textFields[i];
                formFields[textFields[i]] = $(fieldId).val();
            }

            var clearForm = function () {
                for (var i = 0; i < textFields.length; i++) {
                    $(fieldId).val('');
                }
            };

            app.skava.account.login(formFields,
                function() {
                    clearForm();

                    if (selectedShoppingMode === self.CART_SHOPPING_MODE) {
                        window.location.hash = "#checkout";

                    } else {
                        window.location.hash = "#build/info";
                    }
                },

                function(res) {
                    app.page.hideLoader();
                    clearForm();
                    var invalidFields = self.handlePanelError('#account-created-toggle-panel', res);
                    if (invalidFields) {
                        for (var key in invalidFields) {
                            $('#account-created-toggle-panel #field-account-' + key).addClass('error');
                        }
                    }
                }
            );
        },

        /**
         * Contact info
         */
        contactInfoPanel: function() {
            // console.log('contactInfoPanel');
            self.populateAddresses();
            var $btn = $('#contact-info-panel .btn-continue');

            $('#field-contact-email').off('keyup').on('keyup', function(e) {
                if (app.pws.validateEmail($(this).val()) == true) {
                    $btn.removeClass('is-disabled');

                } else {
                    $btn.addClass('is-disabled');
                }

                // submit on enter if valid
                if (e.keyCode == 13 && $btn.hasClass('is-disabled') == false) {
                    $btn.click();
                }
            });

            $('#link-signin a').on('click', function(e) {
                e.preventDefault();
                self.signIn();
            });
        },

        /**
         * Special env for some endpoints
         */
        getEnv: function() {
            var env = 'clone';
            if (['test', 'live'].includes(mode)) {
                env = 'prod';
            }

            return env;
        },

        validateContactInfoPanel: function() {
            // console.log('validateContactInfoPanel');

            app.skava.sendRequest({
                url: '/identity/',
                method: 'POST',
                data: JSON.stringify({
                    email: $('#field-contact-email').val(),
                    env: self.getEnv()
                })
            },

            function(res) {
                // success
                // console.log('identity success');
                if (res) {
                    var result = JSON.parse(res);

                    if (result.identityFound == 'false') {
                        self.identityContinue(true);
                        // populate address email field and hide it
                        fieldSet.address.email = $('#field-contact-email').val();
                        // save email for confirmation screen
                        contactEmail = fieldSet.address.email;
                        $('#field-address-email').val(fieldSet.address.email).attr('disabled', true);
                        $('.address-email-container').hide();

                    } else {
                        // open a brief modal letting user know they already have an account with that address and should sign in
                        app.main.getTemplate('modal-signin', {}, true, function() {
                            app.modal.init();
                            app.modal.load('modal-signin', {});

                            $('#btn-continue-signin').on('click', function(e) {
                                e.preventDefault();
                                app.modal.close();
                                self.signIn();
                            });
                        });
                    }

                } else {
                    console.log('no response');
                }
            },

            function(err) {
                // fail
                // console.log('identity failed');
                console.log(err);
                self.signIn();
            });
        },

        /**
         * Send the password email during headless account creation
         */
        welcome: function() {
            // only if guest
            if (self.isGuest()) {
                console.log('sending welcome email');

                app.skava.sendRequest({
                    url: '/welcome/',
                    method: 'POST',
                    data: JSON.stringify({
                        environment: self.getEnv()
                    })
                },

                function(res) {
                    // success
                    console.log('welcome:', res);
                    app.ga.track('skava-welcome', res);

                },

                function(err) {
                    // fail
                    console.log('welcome failed');
                    console.log(err);
                    app.ga.track('skava-welcome', 'fail');
                });
            }
        },

        /**
         * Log out headless account
         */
        logout: function() {
            // only if guest
            if (self.isGuest()) {
                app.skava.sendRequest({
                    url: '/logout/',
                    method: 'POST',
                    data: {}
                },

                function(res) {
                    // success
                    // console.log('logout success');
                    app.ga.track('skava-logout', 'success');
                },

                function(err) {
                    // fail
                    // console.log('logout failed');
                    console.log(err);
                    app.ga.track('skava-logout', 'fail');
                });
            }
        },

        /**
         * Identity validation success/fail
         */
        identityContinue: function(success) {
            if (success) {
                self.updateHighlightText('#contact-info-panel', $('#field-contact-email').val());
                self.toggleAccordionPanel('#shipping-address-panel');

            } else {
                self.signIn();
            }
        },

        /**
         * Shipping address
         */
        shippingAddressPanel: function() {
            // console.log('shippingAddressPanel');
            // todo: remove textFields/formFields and use fieldSet instead
            $('#shipping-address-panel input').removeClass('error');
            $('.field-error').empty();

            var textFields = ['firstName', 'lastName', 'addressLine1', 'addressLine2', 'city', 'state', 'zip', 'phone', 'email'];
            var formFields = {};
            var i;

            // extract form values
            for (i = 0; i < textFields.length; i++) {
                var fieldId = '#field-address-' + textFields[i];
                formFields[textFields[i]] = $(fieldId).val();
            }

            formFields.country = $('#field-address-country option:checked').val();
            formFields.state = $('#field-address-state option:checked').val();

            var errors = false;
            var required = ['firstName', 'lastName', 'addressLine1', 'city', 'state', 'country', 'zip', 'phone', 'email'];

            for (i = 0; i < required.length; i++) {
                if (!formFields[required[i]]) {
                    errors = true;
                    $('#field-address-' + required[i]).addClass('error');
                    $('.field-error.'+ required[i]).text(app.main.lang('error_required_field'));

                } else {
                    $('#field-address-' + required[i]).removeClass('error');
                }
            }

            if (app.pws.validateEmail($('#field-address-email').val()) == false) {
                errors = true;
                $('#field-address-email').addClass('error');

            } else {
                $('#field-address-email').removeClass('error');
            }

            if (errors) {
                self.toggleAccordionPanel('#shipping-address-panel');
                $('#tab-new-address').click();
                return;
            }

            // format phone
            formFields.phone = formFields.phone.toString();
            formFields.phone = formFields.phone.replace(/[&\/\\#,+()$~%.'":*?<>{}-]/g, '');
            formFields.phone = formFields.phone.replace(/ /g, '');

            if (fieldSet.address.addressId) {
                formFields.addressId = fieldSet.address.addressId;
                formFields.profileAddressId = fieldSet.address.addressId;
                formFields.properties = {
                    isSaveToAddressbook: false
                };
            }

            // submit
            app.page.showLoader();
            $('.info-error').text('').removeClass('show');

            self.submitAddress(formFields, function(methods) {
                // refresh cart
                self.getCart(function() {
                    self.getSummary();

                    if (summary.freeShipping) {
                        // we have to assume the 1st shipping item will be economy
                        methods[0].name = app.main.lang('free_shipping_method');
                        methods[0].cost = 0;
                    }

                    $('#shipping-method-options').html('');
                    var checkedVal = 'checked';

                    for (i = 0; i < methods.length; i++) {
                        var label = methods[i].name,
                            currencySign = '$';

                        if (methods[i].cost > 0) {
                            if (cartData) {
                                if (cartData.currencySign) {
                                    currencySign = cartData.currencySign;
                                }
                            }
                            label += ' - '+ currencySign + methods[i].cost;
                        }

                        // hack in delivery day ranges
                        switch (methods[i].deliveryPeriod) {
                            case 9:
                            case 8:
                                methods[i].deliveryEarlyPeriod = 3;
                            break;
                            case 5:
                            case 2:
                                methods[i].deliveryEarlyPeriod = 1;
                            break;
                        }

                        if (methods[i].deliveryPeriod > 0) {
                            if (methods[i].deliveryEarlyPeriod) {
                                label += ' ('+ app.main.strReplace(app.main.lang('delivery_period'), methods[i].deliveryEarlyPeriod +'-'+ methods[i].deliveryPeriod) +')';

                            } else {
                                label += ' ('+ app.main.strReplace(app.main.lang('delivery_period'), methods[i].deliveryPeriod) +')';
                            }
                        }

                        var fieldId = 'field-ewm-shipmethod-' + methods[i].id;
                        var el = '<div class="radio-field"><input type="radio" id="shipping-method-'+ fieldId
                                +'" name="field-ewm-shipping" value="'+ methods[i].id +'" '+ checkedVal
                                +' /><label for="shipping-method-'+ fieldId + '">'+ label +'</label></div>';
                        $('#shipping-method-options').append(el);
                        checkedVal = ''; // only check the first option
                    }

                    self.updateHighlightText('#shipping-address-panel', formFields.addressLine1);
                    self.toggleAccordionPanel('#shipping-method-panel');
                });

            }, function (res) {
                var response = {};

                try {
                    response = JSON.parse(res.responseText);
                    console.log('----- RESPONSE CODE '+ response.code +' -----');
                    console.log(response);
                    var message = Object.values(response)[0];

                    if (message) {
                        $('#shipping-address-panel .info-error')
                            .html(message)
                            .addClass('show');
                    }

                } catch(err) {
                    console.log('Invalid response.');
                }

                // retry on error 'Unable to update your account. Please contact administrator.'
                // todo: will this error code change?
                if (response.code == 'EOUSE0102') {
                    if (submitRetries > 0) {
                        window.setTimeout(function() {
                            console.log('retries left '+ submitRetries);
                            submitRetries--;
                            self.shippingAddressPanel();
                        }, 1000);

                        return;
                    }
                }

                var invalidFields = self.handlePanelError('#shipping-address-panel', res);

                if (invalidFields) {
                    for (var key in invalidFields) {
                        $('#shipping-address-panel #field-address-' + key).addClass('error');
                    }
                }

                if (response.recommendations) {
                    var chosenAddress = 0;

                    // discard recommendations if the list is long
                    if (response.recommendations.length > 5) {
                        response.recommendations.splice(5);
                    }

                    app.modal.init();
                    app.modal.load('address-modal', {
                        recommendations: response.recommendations
                    });

                    $('input[name=field_address]').on('change', function(e) {
                        chosenAddress = e.currentTarget.value;
                    });

                    $('#btn-address-choose').on('click', function(e) {
                        if (chosenAddress) {
                            self.populateAddressForm(response.recommendations[chosenAddress]);
                        }

                        app.modal.close();
                    });
                }
            });
        },

        /**
         * Call availability
         */
        availability: function() {
            // console.log('availability');

            // only if there is no subscriptionId and sub items are in the cart
            var items = self.getCartSubscriptions();
            var date = new Date();

            if (!subscriptionId && items.length) {
                app.skava.sendRequest({
                    url: '/availability/'+ date.getDate() +'/',
                    method: 'GET'
                },

                function(res) {
                    // success
                    // console.log('availability success');
                    app.ga.track('skava-availability', 'success');
                    self.initLoyalty();
                },

                function(err) {
                    // fail
                    // console.log('availability failed');
                    console.log(err);
                    app.ga.track('skava-availability', 'fail');
                    self.initLoyalty();
                });

            } else {
                // console.log('no subscription items in cart, no check for availability');
                self.initLoyalty();
            }
        },

        /**
         * Convert cart to loyalty order
         */
        convertCart: function() {
            // console.log('convertCart');

            // only if there is no subscriptionId and sub items are in the cart
            var items = self.getCartSubscriptions();
            // console.log(subscriptionId, items);

            if (!subscriptionId && items.length) {
                app.skava.sendRequest({
                    url: '/convert/',
                    method: 'GET'
                },

                function(res) {
                    // success
                    // console.log('convert success');
                    app.ga.track('skava-convert', 'success');
                    self.initLoyalty();
                },

                function(err) {
                    // fail
                    // console.log('convert failed');
                    console.log(err);
                    app.ga.track('skava-convert', 'fail');
                    self.initLoyalty();
                });

            } else {
                // console.log('no subscription items in cart, no conversion');
                self.initLoyalty();
            }
        },

        /**
         * Loyalty endpoint
         */
        initLoyalty: function() {
            // console.log('initLoyalty');

            app.skava.sendRequest({
                url: '/loyalty/',
                method: 'GET'
            },

            function(res) {
                // success
                // console.log('loyalty success');
                app.ga.track('skava-loyalty', 'success');
                self.shippingMethodPanel();
            },

            function(err) {
                // fail
                // console.log('loyalty failed. continuing');
                app.ga.track('skava-loyalty', 'fail');
                self.shippingMethodPanel();
            });
        },

        /**
         * Shipping method chooser
         */
        shippingMethodPanel: function() {
            app.page.showLoader();
            $('#shipping-method-panel .info-error').removeClass('show');

            var $selected = $('input[name="field-ewm-shipping"]:checked'),
                shippingMethod = $selected.val(),
                parsedMethodId = 0;

            if (shippingMethod) {
                var selectedInputId = $selected.attr('id').replace('shipping-method-', ''),
                    shippingMethodTitle = $('label[for="shipping-method-' + selectedInputId + '"]')[0].innerHTML,
                    shippingMethodIdParts = selectedInputId.split('-');

                parsedMethodId = shippingMethodIdParts[shippingMethodIdParts.length - 1];
            }

            app.skava.submitShippingMethod({
                id: parsedMethodId

            }, function() {
                self.updateHighlightText('#shipping-method-panel', shippingMethodTitle);

                // refresh cart
                self.getCart(function() {
                    self.getSummary();
                });

                self.getSavedPaymentMethods(function(data) {
                    var $target = $('#billing-panel');
                    self.toggleAccordionPanel('#billing-panel');

                    // enable address form tabs
                    $('.tabs div', $target).on('click', function(e) {
                        var tab = $(this).data('tab');

                        $('.tabs div,.tab', $target).removeClass('is-active');
                        $(this).addClass('is-active');
                        $('#'+ tab).addClass('is-active');
                        
                        if (tab == 'payments-saved') {
                            if (paymentInfo) {
                                // restore previously selected payment method if returning to this tab
                                delete paymentInfo.disabled;
                                // reset button
                                $('#billing-panel .btn-continue').removeClass('is-disabled');

                            } else {
                                // nothing selected, disable button in case the form was filled out previously
                                $('#billing-panel .btn-continue').addClass('is-disabled');
                            }
                        }

                        if (tab == 'payments-new') {
                            // clear paymentInfo if previously selected
                            if (paymentInfo) {
                                paymentInfo.disabled = true;
                            }
                        }
                    });

                    if (data.length < 1) {
                        $('#tab-new-payment').click();
                        $('#tabs-payments').hide();

                    } else {
                        // check for dupes
                        data = self.deDupe(data);

                        // populate saved addresses
                        $('#tab-saved-payments').text(app.main.lang('tab_saved_payments') +' ('+ data.length +')');
                        $('#payments-saved').empty().html(app.main.getTemplate('partial-payment', { payments: data }));

                        $('.payment input').on('change', function(e) {
                            var index = parseInt($(this).val(), 10);
                            paymentInfo = {};

                            paymentInfo.paymentItems = [{
                                paymentRefId: data[index].id
                            }];

                            paymentInfo.value = self.getGrandTotal();
                            paymentInfo.amount = self.getGrandTotal();
                            paymentInfo.last4 = data[index].accountInfo.cardNumber.substr(-4);

                            $('#billing-panel .btn-continue').removeClass('is-disabled');
                        });
                    }

                    // country
                    $(document).on('change', '#field-billing-country', function (e) {
                        var selected = e.target.selectedOptions;

                        if (selected.length > 0) {
                            selected = selected[0];
                        }
                    });

                    self.initCardFormatting();
                    $('#field-billing-cardExpiration').on('keyup blur', self.updateCreditCardExpiration);

                    self.validateForm('billingAddress');
                    self.validateForm('billing');
                });

            }, function(res) {
                self.handlePanelError('#shipping-method-panel', res);
            });                
        },

        /**
         * Billing payment/address
         */
        billingPanel: function() {
            // console.log('billingPanel');
            // skip validation if a saved payment method is used
            if (paymentInfo && !paymentInfo.disabled) {
                app.page.showLoader();

                self.submitSavedPayment(paymentInfo, function() {

                    var highlightText = 'Card ending in '+ paymentInfo.last4;

                    self.updateHighlightText('#billing-panel', highlightText);

                    self.getCart(function() {
                        self.getSummary();
                    });

                    self.toggleAccordionPanel('#confirm-panel');
                },

                function() {
                    console.log('Error submitting payment info', paymentInfo);
                });

            } else {
                if (sameAsShipping) {
                    fieldSet.billingAddress.addressLine1 = fieldSet.address.addressLine1;
                    fieldSet.billingAddress.addressLine2 = fieldSet.address.addressLine2;
                    fieldSet.billingAddress.city = fieldSet.address.city;
                    fieldSet.billingAddress.country = fieldSet.address.country;
                    fieldSet.billingAddress.state = fieldSet.address.state;
                    fieldSet.billingAddress.zip = fieldSet.address.zip;

                } else {
                    fieldSet.billingAddress.country = $('#field-billingAddress-country option:checked').val();
                    fieldSet.billingAddress.state = $('#field-billingAddress-state option:checked').val();
                }

                fieldSet.billingAddress.firstName = fieldSet.address.firstName;
                fieldSet.billingAddress.lastName = fieldSet.address.lastName;
                fieldSet.billingAddress.email = fieldSet.address.email;
                fieldSet.billingAddress.phone = fieldSet.address.phone;

                // validate
                var errors = false;

                fieldSet.billing.cardNumber = fieldSet.billing.cardNumber.replace(/ /g, '');

                if (fieldSet.billing.cardExpiration.indexOf('/') === -1 || self.updateCreditCardExpiration({ type: 'focusout', which: '' })) {
                    errors = true;
                    $('#field-billing-cardExpiration').addClass('error');

                } else {
                    var pieces = fieldSet.billing.cardExpiration.split('/');

                    if (pieces[0].length != 2 || pieces[1].length != 4) {
                        errors = true;
                        $('#field-billing-cardExpiration').addClass('error');

                    } else {
                        fieldSet.billing.expiryMonth = pieces[0];
                        fieldSet.billing.expiryYear = pieces[1];
                    }
                }

                if (fieldSet.billing.cardNumber.length < 4) {
                    errors = true;
                    $('#field-billing-cardNumber').addClass('error');
                }

                if (errors) {
                    self.toggleAccordionPanel('#billing-panel');
                    return;
                }

                // submit
                app.page.showLoader();
                $('#billing-panel .info-error').removeClass('show');

                self.submitBilling({
                    accountInfo: fieldSet.billing,
                    billingAddress: fieldSet.billingAddress
                },

                function() {
                    var last4 = fieldSet.billing.cardNumber.substr(-4),
                        highlightText = 'Card ending in ' + last4;

                    self.updateHighlightText('#billing-panel', highlightText);

                    // send add_payment_info GA event
                    var gaPaymentData = {
                        'currency': app.global.currency(false).label,
                        'value': self.getGrandTotal(),
                        'coupon': self.getPromoCode(),
                        'payment_type': highlightText,
                        'items': self.gaItems()
                    };

                    app.ga.event('add_payment_info', gaPaymentData);

                    self.getCart(function() {
                        self.getSummary();
                    });

                    self.toggleAccordionPanel('#confirm-panel');
                },

                function(res) {
                    var invalidFields = self.handlePanelError('#billing-panel', res);

                    if (invalidFields) {
                        var addressPanelError = false;

                        for (var category in invalidFields) {
                            for (var key in invalidFields[category]) {
                                if (category === 'accountInfo') {
                                    $('#billing-panel #field-billing-'+ key).addClass('error');

                                } else if (category === 'billingAddress') {
                                    if (key === 'firstName' || key === 'lastName' || key === 'email' || key === 'phone' || sameAsShipping) {
                                        $('#shipping-address-panel #field-billing-' + key).addClass('error');
                                        addressPanelError = true;

                                    } else {
                                        $('#billing-panel #field-billing-' + key).addClass('error');
                                    }
                                }
                            }
                        }

                        if (addressPanelError) {
                            self.toggleAccordionPanel('#shipping-address-panel');
                        }
                    }
                });
            }

            // enable the terms/conditions modal link
            $('#link-accept-terms a').on('click', function(e) {
                e.preventDefault();
                self.openTermsModal();
            });

            // if (pageData.brandPartnerApply) {
            //     $('#link-brand-partner-agree a').on('click', function(e) {
            //         e.preventDefault();
            //         self.openBrandPartnerModal();
            //     });

            //     // all three checkboxes must be checked
            //     $('input[type="checkbox"]').on('change', function(e) {
            //         propertiesData.isTCVersionChecked = $('#field-accept-terms').prop('checked');
            //         propertiesData.isBuilderTermsAndConditionsAgreed = $('#field-brand-partner-agree').prop('checked');
            //         propertiesData.isBPOrderAgreed = $('#field-brand-partner-confirm').prop('checked');

            //         if (propertiesData.isTCVersionChecked && propertiesData.isBuilderTermsAndConditionsAgreed && propertiesData.isBPOrderAgreed) {
            //             $('#submit-order').removeClass('is-disabled');

            //         } else {
            //             $('#submit-order').addClass('is-disabled');
            //         }
            //     });

            // } else {
                // only terms is required
                $('#field-accept-terms').on('change', function(e) {
                    propertiesData.isTCVersionChecked = $(this)[0].checked;

                    if ($(this)[0].checked == true) {
                        $('#submit-order').removeClass('is-disabled');

                    } else {
                        $('#submit-order').addClass('is-disabled');
                    }
                });
            // }
        },

        openTermsModal: function() {
            var template = 'modal-terms-'+ app.main.getLanguageCode(true);

            app.modal.init();
            app.modal.load('terms-modal');

            app.main.getTemplate(template, {}, true, function() {
                $('#terms-content').html(app.main.getTemplate('modal-terms'));
            });

            $('#btn-terms-agree').on('click', function(e) {
                $('#field-accept-terms')[0].checked = true;
                propertiesData.isTCVersionChecked = true;
                $('#submit-order').removeClass('is-disabled');
                app.modal.close();
            });
        },

        // openBrandPartnerModal: function() {
        //     app.main.getTemplate('modal-brandpartner', {}, true, function() {
        //         app.modal.init();
        //         app.modal.load('modal-brandpartner');

        //         $('#btn-close').on('click', function() {
        //             app.modal.close();
        //         });
        //     });
        // },

        /**
         * Opens on order confirmation page after a bek is purchased
         */
        // openBrandPartnerSuccessModal: function() {
        //     app.main.getTemplate('modal-brandpartner-success', {}, true, function() {
        //         app.modal.init();
        //         app.modal.load('modal-brandpartner-success');

        //         $('#btn-virtual-office').on('click', function(e) {
        //             e.preventDefault();
        //             app.modal.close();
        //             window.open('https://www.youngliving.com/vo/#/login', '_blank');
        //         });
        //     });
        // },

        /**
         * Open a loyalty order update modal
         */
        openLoyaltyStatusModal: function() {
            // only open if items were removed and/or added
            if (!loyaltyData.removed.length && !loyaltyData.added.length) {
                // console.log('skipping loyalty status modal');
                return;
            }

            app.main.getTemplate('modal-loyalty-status', {}, true, function() {
                app.modal.init();
                app.modal.load('modal-loyalty-status', loyaltyData);

                $('#btn-continue-checkout').on('click', function(e) {
                    e.preventDefault();
                    app.modal.close();

                    // reset needed here?
                    // loyaltyData.removed = [];
                    // loyaltyData.added = [];

                    // if cart is empty, show the loyalty confirmation screen
                    if (!self.getCartProducts().length) {
                        // cart is empty, we're done
                        self.finishCheckout('LOYALTY_ONLY');
                    }
                });
            });
        },

        /**
         * Order confirmation/review
         */
        orderConfirmPanel: function() {
            // proceed with order
            app.page.showLoader();
            $('#confirm-panel .info-error').removeClass('show');

            // todo: now that subscriptions are sent before checkout completion, we can remove this
            // and go straight to completeOrder
            // if subscription(s) present, then handle separately
            var items = self.getCartSubscriptions();

            if (items.length && subscriptionId) {
                console.log('submit subscriptions first');
                var product, sku, totalCost = 0;

                items.forEach(function(item) {
                    sku = item.skus[0];
                    product = self.getProductByID(sku.productId);

                    if (product) {
                        var exists = loyaltyData.added.find(function(item2) {
                            return item2.product_id === product.product_id;
                        });

                        if (!exists) {
                            loyaltyData.added.push(product);
                            totalCost += product.price;

                        } else {
                            console.log('skipped adding dupe loyalty item to modal');
                        }

                    } else {
                        // there should never be a case where product is false at this point
                        console.log('product '+ sku.productId +' not found');
                    }
                });

                var subData = {
                    "items": items,
                    "totalCost": app.global.round(totalCost),
                    "referralId": app.main.getProfile().member_id,
                    "subscriptionId": subscriptionId
                };

                self.createSubscription(subData,
                    function(res) {
                        // success
                        // console.log('subscriptions submit ok');

                        self.deleteCartSubscriptions(
                            function(data) {
                                // finished
                                self.completeOrder();
                            }
                        );
                    },

                    function(err) {
                        // error
                        // console.log('subscriptions submit error', err);
                        var errorMessage = 'Create subscriptions failed.';

                        if (err.responseText) {
                            var resText = JSON.parse(err.responseText);
                            if (resText.message) {
                                // already subscribed to this item
                                errorMessage = resText.message;
                            }

                            if (resText.responseMessage) {
                                // user not found
                                errorMessage = resText.responseMessage;
                            }
                        }

                        app.message.alert({
                            type: 'error',
                            id: 'error-subscriptions',
                            message: errorMessage
                        });

                        // remove subscription items and continue to avoid converting to one-time orders
                        self.deleteCartSubscriptions(
                            function(data) {
                                // finished
                                self.completeOrder();
                            }
                        );
                    }
                );

            } else {
                self.completeOrder();
            }
        },

        completeOrder: function(form) {
            var oneTimeOrders = self.getCartProducts();

            var formFields = {
                kits: pageData.kits,
                products: pageData.products,
                monthly: pageData.monthly,
                PSKMonth1: pageData.PSKMonth1
            };

            // todo: make sure this is ok to submit if a subscriptionId exists
            // if (oneTimeOrders.length) {
                // console.log('one-time orders found, submitting');

                app.skava.submitOrder(formFields, function(orderResults) {
                    app.page.showLoader();
                    self.finishCheckout(orderResults.orderId);

                }, function (res) {
                    self.handlePanelError('#confirm-panel', res);
                    app.page.hideLoader();
                });

            // } else {
            //     console.log('no one-time items to purchase');
            //     self.finishCheckout('LOYALTY_ONLY');
            //     app.page.hideLoader();
            // }
        },

        finishCheckout: function(orderNumber) {
            app.ga.track('CART', 'Success');
            app.page.hideLoader();
            $('#summary-container, .add-your-info, #package-welcome, #nav-steps').hide();
            $('.profile-container, #member-card').removeClass('is-hidden');
            $('#enrollment').removeClass('no-margin');
            enrollmentComplete = true;

            $('#checkout-row').hide();

            if (orderNumber == 'LOYALTY_ONLY') {
                $('#checkout-complete').html(app.main.getTemplate('checkout-complete-loyalty', {
                    orderNumber: orderNumber
                })).show();

            } else {
                $('#checkout-complete').html(app.main.getTemplate('checkout-complete', {
                    orderNumber: orderNumber,
                    emailAddress: contactEmail
                })).show();

                // special tracking for new headless account orders
                if (contactEmail) {
                    app.ga.track('skava-headless', 'create');
                    // console.log('skava-headless: create');
                }
            }

            // // show brand partner modal if bek was purchased
            // if (pageData.brandPartnerApply) {
            //     self.openBrandPartnerSuccessModal();
            // }            

            if (selectedShoppingMode === self.CART_SHOPPING_MODE && !pageData.brandPartner) {
                app.ga.track('Cart-'+ app.main.getProfile().member_id, 'cart', orderNumber);

            } else {
                app.enroll.trackEnrollmentPackage();
            }

            app.main.resetShopping();
            app.main.toggleNavigation(true);
            window.scrollTo(0,0);
            self.clearSessionId();
        },

        /**
         * Send final order data to our api
         */
        sendOrderData: function(data) {
            // console.log('sendOrderData v2/order payload:', data.payload);
            self.sendRequest({
                useAPI: true,
                url: 'v2/order/',
                method: 'POST',
                data: JSON.stringify({"payload": data.payload})

            }, function(res) {
                // console.log('success', res);

            }, function(err) {
                console.log('Error sending order data to superadmin', err);
            });
        },

        // handle panel error
        handlePanelError: function(panelId, res) {
            app.page.hideLoader();
            var error = {};

            if (res.responseText) {
                try {
                    error.invalidFields = JSON.parse(res.responseText);

                    if (error.invalidFields.message) {
                        error.message = error.invalidFields.message;

                        switch (error.message.toLowerCase()) {
                            case 'address provided is invalid':
                                $('#field-billing-addressLine1').addClass('error');
                            break;

                            // todo: verify this message
                            case 'payment invalid':
                                error.message = app.main.lang('error_payment_invalid');
                            break;
                        }
                    }

                    if (error.invalidFields.errorMessage) {
                        error.message = error.invalidFields.errorMessage;
                    }

                } catch (err) {
                    // console.log('Could not parse JSON for ' + panelId);
                    console.log(err);
                    error = {
                        message: 'Unknown error. Please try again.'
                    };
                }

            } else {
                if (errorBanners) {
                    app.message.alert({
                        type: 'critical',
                        id: 'error-unknown',
                        message: app.main.lang('skava_error_unknown') +' ('+ res.status +')'
                    });
                }
            }

            if (error.message) {
                var code = res.responseText && JSON.parse(res.responseText).code;
                console.log('Code: '+ code);

                // override specific error messages if needed
                switch (code) {
                    case '215':
                    case '285':
                        // Payment Process Failed - Issue with third party service
                        error.message = app.main.lang('skava_error_third_party');
                    break;
                }

                var support = '<p>Need help? <a href="#" class="link-support">Submit a support request</a>.</p>';

                $(panelId + ' .info-error')
                    .html(error.message + support)
                    .addClass('show');

                $('.link-support').on('click', function(e) {
                    e.preventDefault();
                    app.modal.support.init();
                });
            }

            if (error.invalidFields) {
                return error.invalidFields;
            }

            if (errorBanners) {
                app.message.alert({
                    type: 'error',
                    id: 'error-unknown',
                    message: app.main.lang('skava_error_unknown') +' ('+ res.status +')'
                });
            }
        },

        /**
         * Handle form field validation
         */
        validateForm: function(type) {
            var id = '';

            switch (type) {
                case 'signup':
                    id = '#signup-toggle-panel';
                break;

                case 'address':
                    id = '#shipping-address-panel';

                    $('#field-address-country').on('change', function(e) {
                        fieldSet.address.country = $('#field-address-country option:checked').val().toUpperCase();
                    });

                    $('#field-address-state').on('change', function(e) {
                        fieldSet.address.state = $('#field-address-state option:checked').val().toUpperCase();
                    });
                break;

                case 'billing':
                    id = '#billing-panel';
                break;

                case 'billingAddress':
                    id = '#billing-address';

                    $('#field-billingAddress-country').on('change', function(e) {
                        fieldSet.billingAddress.country = $('#field-billingAddress-country option:checked').val().toUpperCase();
                    });

                    $('#field-billingAddress-state').on('change', function(e) {
                        fieldSet.billingAddress.state = $('#field-billingAddress-state option:checked').val().toUpperCase();
                    });
                break;
            }

            $(id +' .field input,'+ id +' .field select').off('blur').on('blur', function(e) {
                var fieldName = e.currentTarget.id.split('field-'+ type +'-')[1];
                var $field = $(e.currentTarget);

                fieldSet[type][fieldName] = $field.val();

                $field.removeClass('error');
                $('.field-error.'+ fieldName).empty();

                if (!$(e.currentTarget).val() && fieldSet[type].required.includes(fieldName)) {
                    $(e.currentTarget).addClass('error');
                    $('.field-error.'+ fieldName).text(app.main.lang('error_required_field'));
                }

                switch (fieldName) {
                    case 'firstName':
                    case 'lastName':
                        if ($field.val() && regexMap.alpha.test($field.val()) == false) {
                            $field.addClass('error');
                            $('.field-error.'+ fieldName).text(app.main.lang('error_name_invalid'));
                        }
                    break;

                    case 'zip':
                        if ($field.val() && regexMap.zip.test($field.val()) == false) {
                            $field.addClass('error');
                            $('.field-error.'+ fieldName).text(app.main.lang('error_zip_invalid'));
                        }
                    break;

                    case 'phone':
                        if (app.pws.validatePhone($('#field-'+ type +'-phone').val()) == false) {
                            $field.addClass('error');
                            $('.field-error.'+ fieldName).text(app.main.lang('error_phone_invalid'));
                        }
                    break;

                    case 'email':
                        if (app.pws.validateEmail($('#field-'+ type +'-email').val()) == false) {
                            $field.addClass('error');
                            $('.field-error.'+ fieldName).text(app.main.lang('error_email_invalid'));
                        }
                    break;

                    case 'state':
                        // console.log('state is', $field.val());
                    break;

                    case 'cardExpiration':
                        if ($field.val() && self.updateCreditCardExpiration({ type: 'focusout', which: '' })) {
                            $('.field-error.'+ fieldName).text(app.main.lang('error_expiration_invalid'));
                        }
                    break;
                }

                self.validateFields(id, type);
            });

            // also validate fields here
            self.validateFields(id, type);
        },

        validateFields: function(id, type) {
            var isValid = true,
                $btnContinue = $(id +' .btn-continue');

            $(id +' .field input').each(function(index, field) {
                var splitStr = 'field-address-';

                switch (id) {
                    case '#billing-panel':
                        splitStr = 'field-billing-';
                    break;
                    case '#billing-address':
                        splitStr = 'field-billingAddress-';
                        $btnContinue = $('#billing-panel .btn-continue');
                    break;
                }

                var thisField = $(field).attr('id').split(splitStr)[1];

                if ($(field).hasClass('error') || (!$(field).val() && fieldSet[type].required.includes(thisField))) {
                    isValid = false;
                }
            });

            // no need to validate billing address form if same as shipping
            if (id == '#billing-address' && sameAsShipping) {
                isValid = true;
            }

            if (isValid) {
                $btnContinue.removeClass('is-disabled');

            } else {
                $btnContinue.addClass('is-disabled');
            }
        },

        /**
         * Auto-fill address form
         */
        populateAddressForm: function(obj) {
            if (!obj) {
                return;
            }

            var fields = ['firstName', 'lastName', 'addressLine1', 'addressLine2', 'city', 'state', 'zip', 'phone', 'email'];

            fields.forEach(function(field) {
                if (obj[field]) {
                    $('#field-address-'+ field).val(obj[field]);

                    // also populate fieldSet values
                    if (fieldSet.address[field]) {
                        fieldSet.address[field] = obj[field];
                    }
                }
            });
        },

        populatePaymentForm: function(obj) {
            if (!obj) {
                return;
            }

            var fields = ['name', 'lastName', 'cardNumber', 'cardExpiration', 'cvv'];

            fields.forEach(function(field) {
                if (obj[field]) {
                    $('#field-billing-'+ field).val(obj[field]);

                    // also populate fieldSet values
                    if (fieldSet.billing[field]) {
                        fieldSet.billing[field] = obj[field];
                    }
                }
            });
        },

        renderCheckoutConfirmPanel: function(pageData) {
            pageData.productsByCategory = self.groupProductsByCategory(pageData.products);
            $('#checkout-confirm-container').html(app.main.getTemplate('checkout-confirm', pageData));
        },

        /**
         * Close and disable and product quantity select lists
         */
        closeSelect: function() {
            $(window).off('resize', self.closeSelect);
            // $('#select-list').removeClass('fixed');
            $('.cart .select').removeClass('is-active');
            $('#select-list li').off('click');
            $('#select-list .other input').val('').off('keyup blur');
            $('#select-list').hide();
        },

        initCardFormatting: function() {
            var cleave = new Cleave('#field-billing-cardNumber', {
                creditCard: true,
                onCreditCardTypeChanged: function(type) {
                    $('#card-type').removeClass().addClass(type);
                }
            });
        },

        /**
         * Update and validate cc expiration field
         */
        updateCreditCardExpiration: function(e) {
            var $cardExpirationEl = $('#field-billing-cardExpiration'),
                val = $cardExpirationEl.val(),
                currentYear = new Date().getFullYear(),
                month = '',
                year = '',
                error = false;

            if (val.indexOf('/') > -1) {
                var pieces = val.split('/');
                month = pieces[0].replace(/\D/g,'');
                year = pieces[1].replace(/\D/g,'');

                if (parseInt(month, 10) < 1 || parseInt(month, 10) > 12) {
                    // invalid month
                    error = true;
                } else {
                    if (month.length < 2) {
                        month = '0'+ month;
                    }
                }

                if (year && year.length > 1 && parseInt(year, 10) < currentYear) {
                    // year is before current year (card expired)
                    error = true;
                }

                val = month +'/'+ year;

            } else {

                val = val.replace(/\D/g,'');

                if (e.which !== 8) {
                    if (val && val.length >= 2) {
                        val += '/';
                    }

                    if (parseInt(val, 10) < 1 || parseInt(val, 10) > 12) {
                        error = true;
                    }
                }
            }

            $cardExpirationEl.val(val);

            if (e.type == 'focusout') {
                if (!month || !year) {
                    error = true;
                }

                if (year < currentYear) {
                    error = true;
                }

            }

            if (error) {
                $cardExpirationEl.addClass('error');

            } else {
                $cardExpirationEl.removeClass('error');
            }

            return error;
        },

        getCart: function(cb, errorCb) {
            if (!cb) {
                cb = function() {};
            }

            if (!errorCb) {
                errorCb = function() {};
            }

            // after all updates are made, grab the new grand total (if needed)
            self.sendRequest({
                url: '/cart/',
                method: 'GET'
            },

            function (response, status, xhr) {
                var grandTotal = 0;
                var items = [];

                cartData = JSON.parse(response);
                self.applyDiscount();
                self.getSummary();

                try {
                    grandTotal = self.getGrandTotal() * 100;
                    items = cartData.items;

                } catch (err) {
                    // do nothing
                }

                cb({
                    items: items,
                    grandTotal: grandTotal,
                    res: cartData
                });

            },

            function(err) {
                try {
                    if (err.responseText) {
                        var message = JSON.parse(err.responseText);
                    }

                } catch (err2) {
                    // probably invalid json, server 500 error
                    err = { status: 500 };
                }

                switch (err.status) {
                    // cart exists but is empty, or some other message - cart object is not returned here
                    case 400:
                        if (message.code && message.message) {
                            app.message.alert({
                                type: 'error',
                                id: 'error-skava',
                                message: message.message
                            });
                            app.page.hideLoader();
                        }
                    break;

                    // Incorrect authentication credentials.
                    case 403:
                        self.clearSessionId();
                        self.setUpSession(
                            function() {
                                //
                            },

                            function(error) {
                                //
                            });
                    break;

                    case 500:
                        //app.message.error('Server error 500');
                    break;
                }

                errorCb(err);
            });
        },

        /**
         * Delete the skava cart
         */
        deleteCart: function(callback) {
            if (!callback) {
                callback = function() {};
            }

            app.skava.sendRequest({
                url: '/cart/',
                method: 'DELETE'
            },
            function(res) {
                // console.log('delete cart success');
                callback();
            },
            function(err) {
                // console.log('delete cart failed. status '+ err.status);
                callback();
            });
        },

        /**
         * This does not attempt to load the cart from skava, but returns the cached cart data
         */
        getCartData: function() {
            return cartData;
        },

        /**
         * Shortcut to get grandTotal safely
         */
        getGrandTotal: function() {
            if (cartData && cartData.value && cartData.value.grandTotal) {
                return cartData.value.grandTotal;

            } else {
                return 0;
            }
        },

        /**
         * Get subscriptions separately so they can get submitted on their own
         */
        getCartSubscriptions: function() {
            var subscriptions = [];

            if (cartData) {
                cartData.items.forEach(function(item) {
                    if (item.isSubscription) {
                        var sku = item.skus[0];

                        subscriptions.push({
                            "itemId": item.itemId,
                            "quantity": item.quantity,
                            "skus": [
                                {
                                    "skuId": sku.skuId,
                                    "productId": sku.productId,
                                    "type": 'DEFAULT'
                                }
                            ],
                            "isSubscription": true,
                            "subscription": {
                                "frequencyPeriod": "1",
                                "frequencyType": "MONTHS"
                            },
                            "properties": {}
                        });
                    }
                });
            }

            return subscriptions;
        },

        /**
         * Used to see if any one-time products are in the cart
         */
        getCartProducts: function() {
            var products = [];

            if (cartData) {
                cartData.items.forEach(function(item) {
                    if (!item.isSubscription) {
                        var sku = item.skus[0];

                        products.push({
                            "quantity": item.quantity,
                            "skus": [
                                {
                                    "skuId": sku.skuId,
                                    "productId": sku.productId,
                                    "type": 'DEFAULT'
                                }
                            ],
                            "isSubscription": false,
                            "properties": {}
                        });
                    }
                });
            }

            return products;
        },

        /**
         * Check if the cart is set to guest vs. a logged-in account
         */
        isGuest: function() {
            var guest = false;

            if (cartData) {
                if (cartData.userName && cartData.userName.toLowerCase() == 'guest') {
                    return true;

                } else {
                    return false;
                }

            } else {
                // cartData should exist, but if not, getCart will set it then recursively call isGuest()
                self.getCart(
                    function() {
                        if (cartData) {
                            return self.isGuest();

                        } else {
                            return true;
                        }
                    },

                    function() {
                        // if cart failed, assume guest is true
                        return true;
                    }
                );
            }
        },

        /**
         * Remove any subscription items from the cart
         */
        deleteCartSubscriptions: function(callback) {
            var itemsToDelete = self.getCartSubscriptions();
            // console.log('Remove subscriptions from cart', itemsToDelete);
            var completed = 0;

            itemsToDelete.forEach(function(item) {
                app.skava.sendRequest({
                        url: '/cart/' + item.itemId + '/',
                        method: 'DELETE'
                    },

                    function() {
                        // success
                        // console.log('deleted subscription '+ item.itemId);
                        completed++;
                        if (completed == itemsToDelete.length) {
                            callback();
                        }
                    },

                    function(err1, err2, err3) {
                        // fail
                        // console.log('Failed to delete '+ item.itemId);
                        completed++;
                        if (completed == itemsToDelete.length) {
                            callback();
                        }
                    }
                );
            });
        },

        /**
         * Add subscription items to the cart
         */
        addCartSubscriptions: function(itemsToAdd, callback) {
            if (!itemsToAdd) {
                callback();
            }

            itemsToAdd.forEach(function(item) {
                delete item.itemId;
            });

            // console.log('Add subscriptions to the cart', itemsToAdd);
            var completed = 0;

            app.skava.sendRequest({
                    url: '/cart/',
                    method: 'POST',
                    data: JSON.stringify(itemsToAdd)
                },

                function() {
                    // success
                    // console.log('added subscriptions');
                    callback();
                },

                function(err1, err2, err3) {
                    // fail
                    console.log('Failed to add subscriptions');
                    callback();
                }
            );
        },

        /**
         * Return gift items from skava cart if any exist
         */
        getCartGifts: function() {
            var gifts = [];

            if (cartData) {
                cartData.items.forEach(function(item) {
                    if (item.isGift) {
                        var sku = item.skus[0],
                            product = self.getProductByID(sku.productId);

                        // clone it
                        if (product) {
                            product = JSON.parse(JSON.stringify(product));

                        } else {
                            // build a product object from the sku info
                            product = {
                                product_id: sku.productId,
                                name: sku.skuProperties.name,
                                variant: sku.skuProperties.variant,
                                point_value: sku.skuProperties.pointValue,
                                distributor_point_value: sku.skuProperties.pointValue,
                                image_url: sku.skuProperties.image
                            };
                        }

                        // gift price is always 0
                        product.price = 0;
                        product.retail_price = 0;
                        product.retail_price_with_tax = 0;
                        product.wholesale_price = 0;
                        product.wholesale_price_with_tax = 0;
                        product.image_url = sku.skuProperties.image;

                        // gifts are always in stock
                        product.in_stock = true;

                        gifts.push(product);
                    }
                });
            }

            return gifts;
        },

        /**
         * Find an item in the cart with matching sku_id and isSubscription status
         */
        findItem: function(sku_id, isSubscription) {
            var foundItem = false;

            if (cartData.items) {
                cartData.items.forEach(function(item) {
                    if (!item.isGift) {
                        if (item.isSubscription == isSubscription) {
                            item.skus.forEach(function(sku) {
                                if (sku.skuId == sku_id) {
                                    foundItem = item;
                                }
                            })
                        }
                    }
                })
            }

            return foundItem;
        },

        /**
         * Returns a cart price summary object
         */
        getSummary: function() {
            summary = {
                subtotal: 0.00,
                discount: 0.00,
                tax: 0.00,
                shipping: 0.00,
                total: 0.00,
                freeShipping: false,
                codes: []
            };

            if (cartData) {
                // check for free shipping promo
                try {
                    if (cartData.promotionDetails.promotions) {
                        cartData.promotionDetails.promotions.forEach(function(promo) {
                            // todo: other types of cart promos?
                            if (promo.type == 'CART') {
                                promo.breakup.forEach(function(breakup) {
                                    if (breakup.identifier == 'yNeXVh_0') {
                                        // july10 promo
                                        summary.codes.push({code: 'July10'});

                                    } else {
                                        summary.freeShipping = true;
                                    }
                                });
                            }
                        });
                    }

                } catch(err) {
                    // no promotions, do nothing
                }

                self.applyDiscount();

                if (cartData.value) {
                    summary.subtotal = cartData.value.originalPrice * 100;
                    summary.discount = cartData.value.totalDiscount * 100;
                    summary.tax = cartData.value.taxOnPrice * 100;
                    summary.shipping = cartData.value.deliveryChargeIncludingTax * 100;
                    summary.total = self.getGrandTotal() * 100;
                }

                if ($('#field-promo-code').val()) {
                    summary.promo_code = $('#field-promo-code').val();
                }
            }

            $('#summary-container').html(app.main.getTemplate('checkout-summary', summary));
            $('#promo-container').html(app.main.getTemplate('promo-form', summary));
            self.initPromoForm(summary);
        },

        // Check if a promo code was previously accepted and added to summary data
        getPromoCode: function() {
            if (summary.codes && summary.codes[0]) {
                return summary.codes[0].code;
            }

            return '';
        },

        initPromoForm: function(data) {
            $('#label-promo-code').off('click').on('click', function() {
                var $container = $('#promo-code');

                if ($container.hasClass('is-visible')) {
                    $container.removeClass('is-visible');
                    $('#field-promo-code').val('');

                } else {
                    $container.addClass('is-visible');
                }
            });

            $('#field-promo-code').off('keyup').on('keyup', function() {
                if ($(this).val()) {
                    $('.field-error.promo-code').empty();
                } else {
                    $('.field-error.promo-code').text(app.main.lang('error_promo_code'));
                }
            });

            $('#btn-promo-code').off('click').on('click', function() {
                var value = $('#field-promo-code').val();

                if (value) {
                    $('.field-error.promo-code').empty();

                    self.sendRequest({
                        url: '/promos/',
                        method: 'POST',
                        data: JSON.stringify([{
                            code: value
                        }])
                    },

                    function(response) {
                        // console.log('promo success');
                        if (response) {
                            cartData = JSON.parse(response);
                        }

                        self.applyDiscount();

                        if (app.main.getHash() == 'cart') {
                            app.cart.setCartTotal(self.getGrandTotal() * 100);
                            self.renderCartReview('#cart-review-container', app.cart.getCheckoutFormPageData());
                        }
                        
                        if (app.main.getHash().indexOf('build/review') > -1) {
                            app.enroll.finishRender();
                            app.page.addClickHandler('[data-page]');
                        }

                        self.getSummary();
                        app.ga.track('PromoCode', 'success', value);
                    },

                    function(err) {
                        if (err.responseText) {
                            var response = JSON.parse(err.responseText);
                            $('.field-error.promo-code').text(response.message);
                        }

                        app.ga.track('PromoCode', 'fail', value);
                    });

                } else {
                    $('.field-error.promo-code').text(app.main.lang('error_promo_code'));
                }

            });
        },

        /**
         * Utility function to check skava cart against our product list
         */
        applyDiscount: function() {
            var cart = self.getCartData();

            if (cart) {
                cart.items.forEach(function(item) {
                    var pieces = item.skus[0].skuId.split('_'),
                        product = null,
                        promo = {};

                        product = self.getProductByID(pieces[0], 'item_id');

                        if (product) {
                            promo = {
                                originalPrice: Math.round(item.totalValue.originalPrice * 100),
                                priceAfterDiscount: Math.round(item.totalValue.priceAfterDiscount * 100)
                            };

                            if (promo.originalPrice > promo.priceAfterDiscount) {
                                product.promo = promo;
                                // console.log(product.name, product.promo);

                            } else {

                                if (product.promo) {
                                    // console.log(product.name +' promo cleared');
                                    delete product.promo;
                                }
                            }
                        }
                });
            }
        },

        handleError: function (jqXHR, textStatus, errorThrown) {
            if (!textStatus || typeof textStatus !== 'string' || textStatus === 'error') {
                textStatus = 'Unhandled error. Please try again.';
            }

            if (errorBanners) {
                app.message.error(textStatus);
            }

            if (skavaErrorCallback) {
                skavaErrorCallback(jqXHR, textStatus, errorThrown);
            }
        },

        sendRequest: function(props, cb, errorCb) {
            var requestOptions = {
                url: cartURL[mode] + app.main.getCurrentCulture() + props.url,
                method: props.method,
                contentType: 'application/json; charset=utf-8',
                cache: false,
                dataType: props.dataType || 'text',
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                }
            };

            if (props.useAPI === true) {
                requestOptions.url = apiURL[mode] + props.url;
            }

            requestOptions.beforeSend = function(xhr) {
                if (self.getSessionObj().sid && !props.useAPI) {
                    xhr.setRequestHeader('x-session-id', self.getSessionObj().sid);
                }

                if (self.getToken()) {
                    xhr.setRequestHeader('Authorization', 'Bearer '+ self.getToken());
                }
            };

            // always send promo code if it exists
            // if ($('#field-promo-code').val()) {
            //     var data = {};

            //     if (typeof props.data == 'string') {
            //         var data = JSON.parse(props.data);
            //     }

            //     data.promotionCode = $('#field-promo-code').val();
            //     props.data = JSON.stringify(data);
            // }

            if (props.method === 'POST' || props.method === 'PATCH') {
                requestOptions.data = props.data;
            }

            requestOptions.success = function(data) {
                // console.log('success: '+ requestOptions.url);
                cb(data);
            };

            requestOptions.error = function(jqXHR, textStatus, errorThrown) {
                errorCb(jqXHR, textStatus, errorThrown);
            };

            // console.log('Sending ' + props.method + ' to ' + props.url);
            // console.log(requestOptions);
            $.ajax(requestOptions);
        },

        setUpSession: function (cb, errorCb) {
            if (!cb) {
                cb = function() {};
            }

            if (!errorCb) {
                errorCb = cb;
            }

            // get from local storage if it exists
            self.getSessionObj();

            // if (sessionObj[self.getShoppingMode()].sid) {
            if (sessionObj.sid) {
                // test: don't get cart here and see if anything breaks;
                if (!subscriptionId) {
                    self.getSubscriptions(cb);

                } else {
                    cb();
                }

                return;
            }

            app.skava.sendRequest({
                url: '/session/',
                method: 'GET'
            },

            function(res) {
                // console.log(self.getShoppingMode() +' session success');
                var response = JSON.parse(res);
                var sessionId = response.sid;
                self.setSessionId(sessionId);

                if (response.access_token) {
                    self.setToken(response.access_token);
                }

                if (!subscriptionId) {
                    self.getSubscriptions(function(res) {
                        self.getCart(function(response) {
                            self.getSummary();
                            cb(response);
                        });
                    });

                } else {
                    self.getCart(function(response) {
                        self.getSummary();
                        cb(response);
                    });
                }

                cb();
            },

            function(err) {
                if (err.status == 0) {
                    app.main.showCriticalError('Get session failed. Error '+ err.status);

                } else {
                    errorCb(err);
                }
           });
        },

        // similar to setupSession, but used during the cart checkout process
        refreshSession: function(callback) {
            app.skava.sendRequest({
                url: '/session/',
                method: 'GET'
            },

            function(res) {
                // console.log('session refreshed');
                var response = JSON.parse(res);
                var sessionId = response.sid;
                self.setSessionId(sessionId);

                if (response.access_token) {
                    self.setToken(response.access_token);
                }

                callback();
            },

            function(err) {
                if (err.status == 0) {
                    app.main.showCriticalError('Get session failed. Error '+ err.status);

                } else {
                    callback(err);
                }
           });
        },

        account: {
            create: function(formFields, cb, errorCb) {
                self.sendRequest({
                    url: '/create_account/',
                    method: 'POST',
                    data: JSON.stringify(formFields)
                }, cb, errorCb);
            },

            login: function(formFields, cb, errorCb) {
                self.sendRequest({
                    url: '/login/',
                    method: 'POST',
                    data: JSON.stringify(formFields)
                }, cb, errorCb);
            }
        },

        getSavedAddresses: function(cb) {
            self.sendRequest({
                url: '/address/',
                method: 'GET',
                dataType: 'json'
            }, cb, function(err) {
                // error when no address is available, return empty array
                cb([]);
            });
        },

        getSavedPaymentMethods: function(cb) {
            self.sendRequest({
                url: '/billing/',
                method: 'GET',
                dataType: 'json'
            }, cb, function(err) {
                // error when no payment methods are available, return empty array
                cb([]);
            });
        },

        submitAddress: function(formFields, cb, errorCb) {
            var url = '/address/';
            // enable the line below to skip recommendations
            // url += '?override=1';

            // if guest account
            if (self.isGuest()) {
                url += '?guest=1';
            }

            self.sendRequest({
                url: url,
                method: 'POST',
                data: JSON.stringify(formFields),
                dataType: 'json'
            }, cb, errorCb);
        },

        submitShippingMethod: function(formFields, cb, errorCb) {
            self.sendRequest({
                url: '/shipping/',
                method: 'POST',
                data: JSON.stringify(formFields)
            }, cb, errorCb);
        },

        submitBilling: function(formFields, cb, errorCb) {
            self.sendRequest({
                url: '/cart/',
                method: 'GET'

            }, function (response, status, xhr) {
                cartData = JSON.parse(response);

                formFields.value = self.getGrandTotal();
                formFields.amount = self.getGrandTotal();

                if (selectedShoppingMode === self.CART_SHOPPING_MODE) {
                    productsTotal = formFields.value;
                }

                var submitPayment = function () {
                    self.sendRequest({
                        url: '/billing/',
                        method: 'POST',
                        data: JSON.stringify(formFields)
                    }, cb, errorCb);
                };

                if (cartData.payments && cartData.payments.length > 0) {
                    self.sendRequest({
                        url: '/billing/',
                        method: 'DELETE'
                    }, submitPayment, errorCb);

                } else {
                    submitPayment();
                }
            }, errorCb);
        },

        submitSavedPayment: function(data, cb, errorCb) {
            // in case of a retry, clear billing first
            self.sendRequest({
                url: '/billing/',
                method: 'DELETE'

            }, function(res) {
                // success
                self.sendRequest({
                    url: '/billing/',
                    method: 'POST',
                    data: JSON.stringify(data)
                }, cb, errorCb);

            }, function(err) {
                // error
                errorCb(err);
            });
        },

        submitOrder: function(formFields, cb, errorCb) {
            // console.log('submitOrder: GET cart (active)');
            self.sendRequest({
                url: '/cart/',
                method: 'GET'
            },

            function (response, status, xhr) {
                cartData = JSON.parse(response);

                propertiesData.referralId = app.main.getProfile().member_id;
                // console.log('submitOrder: POST properties');

                self.sendRequest({
                    url: '/properties/',
                    method: 'POST',
                    data: JSON.stringify(propertiesData)
                },

                function() {
                    // console.log('submitOrder: GET order');
                    self.sendRequest({
                        url: '/order/',
                        method: 'GET'
                    },

                    function(res) {
                        // console.log('submitOrder: POST order');

                        self.sendRequest({
                            url: '/order/',
                            method: 'POST',
                            data: {}
                        },

                        function(res) {
                            // console.log('order success');
                            // trigger password email
                            self.welcome();
                            // set long redirect cookie in case of email signin
                            self.setRedirectCookie(true);

                            var orderResults = JSON.parse(res);

                            self.gaEcommerce(orderResults.orderId);
                            self.gaPurchase(orderResults.orderId);
                            self.logout();
                            cb(orderResults);
                        },

                        function(err) {
                            console.log('submit order failed');
                            errorCb(err);
                            self.logout();
                        });
                    },

                    function(err) {
                        console.log('review order failed');
                        errorCb(err);
                    });

                }, errorCb);
            }, errorCb);
        },

        /**
         * Proxy to get product based on cart type
         */
        getProductByID: function(id, type) {
            if (!type) {
                type = 'product_id';
            }

            var cartProduct = false;

            if (selectedShoppingMode === this.CART_SHOPPING_MODE) {
                cartProduct = app.cart.findProductByID(id, type);

            } else {
                cartProduct = app.enroll.getProductByID(id, type);
            }

            return cartProduct;
        },

        /**
         * Send ecommerce tracking to GA
         **/
        gaEcommerce: function(orderId) {
            if (typeof ga == 'undefined') {
                return;
            }

            var cartItems = cartData.items;

            for (var i = 0; i < cartItems.length; i++) {
                var sku = cartItems[i].skus[0];
                var productId = parseInt(sku.productId, 10);
                var cartProduct = null;
                var category = null;

                cartProduct = self.getProductByID(productId);

                if (cartProduct) {
                    if (cartProduct.categories.length > 0) {
                        category = self.getCategoryByID(cartProduct.categories[0]);
                    }

                    var item = {
                        'id': orderId,
                        'name': cartProduct.name,
                        'sku': cartProduct.sku_id,
                        'category': category ? category.name : 'None',
                        'price': cartItems[i].totalValue.grandTotal,
                        'quantity': cartItems[i].quantity,
                        'currency': app.global.currency(false).label
                    };

                    ga('ecommerce:addItem', item);

                } else {
                    console.log('cartProduct not found: '+ productId);
                }
            }

            var transactionType = '';

            if (selectedShoppingMode === app.skava.BWM_SHOPPING_MODE) {
                transactionType = 'default-bwm';

            } else {
                transactionType = 'cart';
            }

            var transaction = {
                'id': orderId,
                'affiliation': app.main.getProfile().member_id,
                'revenue': self.getGrandTotal(),
                'shipping': cartData.value.totalDeliveryCharge,
                'tax': cartData.value.overAllTax,
                'dimension7': transactionType
            };

            ga('ecommerce:addTransaction', transaction);
            ga('ecommerce:send');
        },

        /**
         * Send purchase tracking to GA v4
         **/
        gaPurchase: function(orderId) {
            if (typeof gtag == 'undefined') {
                // return;
            }

            var gaPurchaseData = {
                'transaction_id': orderId,
                'affiliation': app.main.getProfile().member_id,
                'value': self.getGrandTotal(),
                'tax': cartData.value.overAllTax,
                'shipping': cartData.value.totalDeliveryCharge,
                'currency': app.global.currency(false).label,
                'coupon': self.getPromoCode(),
                'items': self.gaItems()
            };

            app.ga.event('purchase', gaPurchaseData);
        },

        /**
         * Returns skava cart items formatted as a list of GA v4 items
         */
        gaItems: function() {
            var gaItems = [];

            if (cartData && cartData.items) {
                cartData.items.forEach(function(cartItem, i) {
                    var sku = cartItem.skus[0],
                        productId = parseInt(sku.productId, 10),
                        cartProduct,
                        category;

                    cartProduct = self.getProductByID(productId);

                    if (cartProduct) {
                        if (cartProduct.categories.length > 0) {
                            category = self.getCategoryByID(cartProduct.categories[0]);
                        }

                        var item = {
                            'item_id': cartProduct.sku_id,
                            'item_name': cartProduct.name,
                            'affiliation': app.main.getProfile().member_id,
                            // 'coupon': '',
                            // 'currency': app.global.currency(false).label,
                            // 'discount': 0,
                            'index': i,
                            'item_brand': cartProduct.isSubscription ? 'Loyalty Order' : 'Individual Item',
                            'item_category': category ? category.name : 'None',
                            'item_variant': cartProduct.variant,
                            // 'location_id': '',
                            'price': cartItem.totalValue.grandTotal,
                            'quantity': cartItem.quantity
                        };

                        gaItems.push(item);

                    } else {
                        console.log('cartProduct not found: '+ productId);
                    }
                });                
            }

            return gaItems;
        },

        /**
         * Handles messages received from the login iframe
         */
        messageHandler: function(message) {
            if (message == 'login-success') {
                // attempt to delete an existing cart
                // console.log('login success... delete cart here...');

                // self.deleteCart(function() {
                    // another session call
                    self.refreshSession(function() {
                        if (selectedShoppingMode === self.CART_SHOPPING_MODE) {
                            window.location.hash = "#checkout";

                        } else {
                            window.location.hash = "#build/info";
                        }
                    });
                // });

            } else {
                console.log('Unknown message: ', message);
            }

            // remove the listener
            $(window).off('message');
        },

        /**
         * Get pv for specified product
         */
        getPV: function(productID, callback, errorcallback) {
            var url = '/point_value/'+ productID +'/';
            self.sendRequest({
                url: url,
                method: 'GET',
                dataType: 'json'
            }, callback, errorcallback);
        },

        decodeToken: function(token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        }
    };

    return self;
}());
